import { Capacitor } from '@capacitor/core';

import { CANONICAL_APP_HOST } from './canonicalUrl';

const PRODUCTION_HOST = CANONICAL_APP_HOST;

/** Resolves in-app path for supported deep link URLs (for tests and callers). */
export function resolveDeepLinkPath(urlString: string): string | null {
  let url: URL;
  try {
    url = new URL(urlString);
  } catch {
    return null;
  }
  if (url.protocol === 'https:' && url.hostname === PRODUCTION_HOST) {
    const p = `${url.pathname}${url.search}${url.hash}`;
    return p && p !== '' ? p : '/';
  }
  if (url.protocol === 'donegrading:' && url.hostname === 'app') {
    const p = `${url.pathname}${url.search}${url.hash}`;
    return p && p !== '' ? p : '/';
  }
  return null;
}

export function applyDeepLinkUrl(urlString: string): void {
  const next = resolveDeepLinkPath(urlString);
  if (!next) return;
  const normalized = next.startsWith('/') ? next : `/${next}`;
  const current = window.location.pathname + window.location.search + window.location.hash;
  if (normalized === current) return;
  window.location.replace(normalized);
}

export async function setupMobileDeepLinks(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  const { App } = await import('@capacitor/app');
  const launch = await App.getLaunchUrl();
  if (launch?.url) applyDeepLinkUrl(launch.url);
  await App.addListener('appUrlOpen', ({ url }) => {
    applyDeepLinkUrl(url);
  });
}
